module.exports = __webpack_public_path__ + "img/ring_g_i_0_0@2x.38818115.png";